import React from "react";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import styled from "styled-components";
import Container from "../../../components/atoms/Container";
import logo from "../../../assets/home/logo-dark.svg";
import Button from "./navButton";
import DirectMailActionButton from "../../../components/organisms/Buttons/PreApprovedMailAction";

const Header = styled.header`
  position: relative;
  & .wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: var(--header-height);
    z-index: 999;
  }
  & #burder-menu-btn {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
  }

  .logo img {
    height: 50px;
  }

  & nav {
    margin-top: 10px;
  }

  & nav {
    & ul {
      list-style: none;
      display: flex;
      align-items: center;
      column-gap: 2rem;
    }
  }

  @media screen and (max-width: 600px) {
    .logo img {
      height: 30px;
    }

    & nav {
      ul li:not(:last-child) {
        display: none;
      }
    }
  }

  .external-link{
    font-size: 12px;
  font-weight: 700;
  transition: all 0.2s;

  &,
  &:visited {
    text-decoration: none;
    line-height: 1.5;
    color: var(--color-main-2);
    text-transform: uppercase;
  }

  &.selected {
    color: var(--color-blue-1);
  }
  }
`;

const HeaderComponent = ({ toggleMenu }) => {
  const url = `https://app.payplan.ai/amicus/amicus/application/authorization/login`;
  return (
    <Header className="header">
      <Container>
        <div className="wrapper">
          <div className="logo">
            <Link to="/">
              <img
                src={logo}
                alt={`${String(
                  process.env.REACT_APP_TRIBE_NAME,
                ).toLowerCase()}-lending`}
              />
            </Link>
          </div>
          <DirectMailActionButton />
          <nav>
            <ul className="header-menu-list header-menu-list-lg">
              <li>
                <Button to="/about" className="navlink">
                  about us
                </Button>
              </li>
              <li>
                <Button to="/loans" className="navlink">
                  our loans
                </Button>
              </li>
              <li>
                <Button to="/" className="navlink">
                  apply
                </Button>
              </li>
              <li>
                <a href={url} className="navlink external-link" target="_blank">
                  my account
                </a>
              </li>
              <li>
                <button type="button" id="burder-menu-btn" onClick={toggleMenu}>
                  <MenuIcon sx={{ fontSize: 24 }} />
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </Container>
    </Header>
  );
};

export default HeaderComponent;
